(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comments_lists"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.customers-images  img').forEach(img => {
	  img.addEventListener('click',  () => {
	    const modal = document.createElement('div'); 
	    modal.innerHTML  = `
	      <div style="position:fixed;top:0;left:0;width:100%;height:100%;
	        background:rgba(0,0,0,0.8);z-index:999;display:flex;
	        justify-content:center;align-items:center;">
	        <img src="${img.dataset.maximg  || img.src}"  style="max-width:90%;max-height:90%">
	      </div>
	    `;
	    modal.querySelector('div').addEventListener('click',  () => modal.remove()); 
	    document.body.appendChild(modal); 
	  });
	});

    document.addEventListener('DOMContentLoaded',  function() {
    // 所有客户评价数据 
    const customerData = [
        {
            name: "T.R",
            rating: 5,
            comment: "I got this as Christmas gift for my boyfriend. It came out good. The quality of product is amazing. You wind the handle and it changes the picture you picked. So in love",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1.jpg?v=1764138001", 
            productImage: "https://diygiftly.com/cdn/shop/files/7e61a491-0911-4b7b-bcda-599212cc0c02-0_948e8063-8a58-4e3c-8502-c649b27165d0.png?v=1763951614&width=144", 
            productTitle: "Custom Photo Flipbook Frame Animation Machine Mechanical Hand-cranked Flipbook Box Photo Album with Light Black Walnut Anniversary Gifts"
        },
        {
            name: "Dehnhoff.S",
            rating: 5,
            comment: "love how the rings turned out! My sister/best friend share the same birthday month so I gifted one to her and she loved it!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/8Se7VuJJTrAaciEM_6f7d2b06-1a90-4032-8d66-4cf0b84d6f8d.jpg?v=1764138686", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1-81-1296x-1-1800x.webp?v=1764139037", 
            productTitle: "Personalized Birthstone Photo Ring 2 Photo Colors Custom Jewelry Perfect Gift for Her Valentine's Day Gifts"
        },
        {
            name: "Marissa.G",
            rating: 5,
            comment: "I loved these gifts. The music and photo quality it great! I'm going to definitely order more for the holidays. My only issue was that one of my photos had a scratch on them. I took it out the packaging like that, so I'm assuming it happened during it being made, but my other magnet was perfect. Love them so much.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/N1hE06KAd0KWxl8m_d03fddaf-fa01-413e-985b-722f9a2f09d0.jpg?v=1764140339", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P335X02-3.webp?v=1764140509", 
            productTitle: "Custom Music Fridge Magnet Personalized Rectangle Music Fridge Magnet Can Play Songs"
        },
        {
            name: "Cindy.J",
            rating: 5,
            comment: "It's a beautiful bracelet to remember baptism. The company was very professiinal to personalize with my photo.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/tak99aBXQPaCfvWH_ab108201-3743-422b-9ad8-a3e1278474af.jpg?v=1764140591", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/SSL-2294-0007.webp?v=1764140645", 
            productTitle: "Personalized Photo Projection Beads Bracelet With Cross Memorial Gift For Her"
        },
        {
            name: "Tanya.M",
            rating: 5,
            comment: "Beautiful. I had to buffet it but once cleaned, it looks great",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/jbL7mtMDPH6JiYYK_20a482e4-9bc5-4aa1-aa30-23d6e083aa6d.jpg?v=1764144477", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/20220920-142040.webp?v=1764144552", 
            productTitle: "Custom Men's Stainless Steel Bracelet Anniversary Gift For Personalizing Your Special Date"
        },
        {
            name: "Ivan.C",
            rating: 5,
            comment: "Surprised my wife with this and she loved it! Great gift idea!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/UKzryE9rtGEHmWUe_4116d77c-6808-40cd-b216-12db1cb78f72.jpg?v=1764144620", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P206X05.webp?v=1764144737", 
            productTitle: "Personalized 4 Photo Music Fridge Magnet Pro Album Fridge Magnet Music Wall That Can Be Played Photo Sticker Music"
        },
        {
            name: "Raven.S",
            rating: 5,
            comment: "Thank you for the items. They are so cute and my kids loved them. No issue with items.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/nE8rJRLbeejUa6mr_0e3877f2-27cb-432d-8780-965a999d94fa.jpg?v=1764144816", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XHD0P421X16-939badbe-2c55-4f7d-ab65-4078807552a4.webp?v=1764144884", 
            productTitle: "Custom Neon Lamp Personalized Name Neon Sign Adjustable Lamp Creative Decor for Bedroom"
        },
        {
            name: "Melody.F",
            rating: 5,
            comment: "I was so blown away that they had my dad's music as an option after he just recently passed...and it plays the entire song!! I will be buying more and they are the most beautiful and amazing gift... I am so grateful for this... #RememberingSteveFoster",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2fqsufIIGd3zdJ8Y_17f6cef0-7717-44b5-a94a-4a329c77daaf.jpg?v=1764144925", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P335X06-3.webp?v=1764145054", 
            productTitle: "Customized Album Fridge Magnet Personalized Rectangle Music Fridge Magnet Can Play Songs"
        },
        {
            name: "Laurie.A",
            rating: 5,
            comment: "I love this, it's a gift for my mom. I just lost my sweet sister. The photo is upside down in the heart but still beautiful, we projected it on the wall",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/IszaI8u7Bfg2graB_d44df6b2-8e70-4d25-a85d-c37f69e0fda1.jpg?v=1764145085", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1-17.webp?v=1764145177", 
            productTitle: "Personalized Angel Photo Ornament Christmas Gifts"
        },
        {
            name: "Gonzalo.C",
            rating: 5,
            comment: "My bf loves it so much. Very unique gift for couples and also for long distance ones.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XgGuVSDCSE65EyO7_e348b452-246e-444d-bac3-9fe32fd312d7.jpg?v=1764145247", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/Black.webp?v=1764145319", 
            productTitle: "Custom Music Fridge Magnet New 4.0 Upgrade Colorful Frame Album Fridge Magnet Music Wall Photo Sticker Music Movement That Can Be Played Gift for Couple"
        },
        {
            name: "Hayden Bartlett",
            rating: 5,
            comment: "I received this gift box with the rose-shaped necklace and I couldn't be happier! The engraved heart necklace is such a beautiful piece of jewellery.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/ZiSynrh6Ha9RuHcU.jpg?v=1764145396", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XHBPJJ0P467X01.webp?v=1764145496", 
            productTitle: "Engraved Heart Necklace with Real Rose Bear Giftbox Rose Shaped Necklace Gift Box Jewellery Gift Box"
        },
        {
            name: "Lily",
            rating: 5,
            comment: "I am obsessed with this necklace! I got it to hold photos of my children. I love the tone of the opal and the chain is so dainty and beautiful. Highly recommend for a beautiful keepsake!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/LhhRTRlf3URqRCFm_e14ed4fa-715b-4ed8-8f91-859e7e639d7f.jpg?v=1764145572", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/TPNL1354.webp?v=1764145663", 
            productTitle: "Custom Photo Necklace Pearl Surface Creative Pendant Gifts"
        },
        {
            name: "Amber",
            rating: 5,
            comment: "",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_c69b7c57-8ae5-4f75-b91c-954fd97cac6a.webp?v=1764145845", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/681b2a6597235.webp?v=1764145925", 
            productTitle: "My husband loved his personalized bobble head! Great Birthday present!"
        },
        {
            name: "Megi",
            rating: 5,
            comment: "The chain and pendant itself are great quality! I did get this as a gift for my boyfriend and it did not fit his neck but I suspected that it wouldn’t so I had an extender ready. The photo is super clear and exactly what I was hoping for, this was such a meaningful gift. It arrived a few days late, which is in no way the seller’s fault! The seller had great communication before and after the necklace was shipped. I would just say to avoid late arrival, order in advance if it is gift.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/iap_300x300.5008293223_m3bl5qqy.webp?v=1764147205", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/TYNL1193.webp?v=1764147290", 
            productTitle: "Circle Pendant Personalized Photo Projection Necklace Custom Cute Jewelry Anniversary Gifts"
        },
        {
            name: "Kerry",
            rating: 5,
            comment: "So happy with this beautiful bracelet. Either looking to the sun or flashing the light projects the photo.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3_5f2dc69b-c6fd-4b1d-af32-46ea14877c05.webp?v=1764147375", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3.3.webp?v=1764147489", 
            productTitle: "Custom Photo Projection Bracelets Simple Woven Father's Day Gifts"
        },
        {
            name: "Suzzie",
            rating: 5,
            comment: "Very good quality product Finish and photo really well done Thank you very much Very fast shipping in addition!!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4_33e6a05f-b53a-481e-b009-625461add66b.webp?v=1764148252", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4.4.jpg?v=1764148319", 
            productTitle: "Custom Photo Engraved Wallet  Shadow Leather Simple Gifts"
        },
        {
            name: "Brandon",
            rating: 5,
            comment: "I love my phone case!! It is very well made, actually better than I expected! The picture I provided was clear and perfectly positioned, and the case protects my phone all the way around. soufeel answered my questions quickly and I received my product in good time . I highly recommend this business!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3_099a7285-6dda-4bff-a1aa-92d51e93ce9a.webp?v=1764148388", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/8_40097ac8-afaf-4300-bd3c-5b0068c020a1.webp?v=1764148446", 
            productTitle: "Custom Spotify Code Music iPhone Case with Text Scannable Engraved Custom Music Song Tempered Glass  - Black"
        },
        {
            name: "Hailey",
            rating: 5,
            comment: "It’s beautiful. Can’t speak more for that. I think it’s the perfect present. High quality and no sharp edges! I like the size it’s not big or too small. The numbers are legible. Fast shipping and replies very quick to questions and concerns. A++++",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4_96adbf40-2fd8-4c34-a99d-fe49e5dad965.webp?v=1764148505", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/44_bce58925-69b4-46ba-a470-e3408b90a1a9.webp?v=1764148560", 
            productTitle: "Personalised Calendar Keychain, Date Keychain, Anniversary, Boyfriend, Girlfriend, Husband, Wife, Relationships, Wedding"
        },
        {
            name: "Vanessa Turner",
            rating: 5,
            comment: "When I received the item I was blown away at how well it turned out and how good of quality it was. My boyfriend loved his gift! Also, the communication was thorough throughout the entire process. It was friendly, professional, attentive, and encouraging. I highly recommend this product/ seller.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_c69d0e2b-8d40-4114-bd86-8cd1be61f92a.webp?v=1764148623", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/22.webp?v=1764148675", 
            productTitle: "Custom Leather Photo Text Keychain Anniversary Gift For Boyfriend With Engraved Text"
        },
        {
            name: "Rebecca Maiden",
            rating: 5,
            comment: "I purchased the photo watch charm for my husband. The seller responded to all my questions/request very quickly as well as received the product within 2 week. My husband and I love it very much! I would definitely recommend soufeel to everyone.. A++++++",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1_3b596baa-054c-4920-8350-098cbaae6e27.webp?v=1764148727", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/6_4d53058a-8bd3-4476-bc91-8773402ac22b.webp?v=1764148778", 
            productTitle: "Engraved Men's Black Alloy Bracelet Photo Watch To My Dad I Love You Gifts for Him"
        },
        {
            name: "Lisa Reaves",
            rating: 5,
            comment: "This was a gift for my 17 year old after losing my husband and his father unexpectedly and suddenly three days after he turned 17. He says it’s perfect and it loves it!! I reminder he is always with him!! They did a beautiful job and I will be ordering another one for myself :)",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_dbb61a22-ef82-43ee-849e-a6b168dd40b6.webp?v=1764148858", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/22_379090bd-c3a7-4183-9404-42d0befaecce.webp?v=1764148909", 
            productTitle: "Custom Photo And Engraved Stainless Steel Bracelet Best Gifts for Men Gift For Couple"
        },
        {
            name: "Carrie",
            rating: 5,
            comment: "Just amazing The 3 name ring is just perfect I got soooooooo many compliments already Thank you so much",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4.webp?v=1764148966", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/9_92170164-4a03-44cc-a184-4e04d4497330.webp?v=1764149019", 
            productTitle: "Three Name Ring 14K Gold Plated Silver"
        },
        {
            name: "JulesIz",
            rating: 5,
            comment: "Absolutely stunning!!! The code scans perfectly and the picture came out so clear. It’s going to be a perfect graduation gift for my best friend",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_3bc39705-c320-46dd-82c0-f11bf6a0f058.webp?v=1764149076", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2.2.webp?v=1764149125", 
            productTitle: "Custom Music Code Music Plaques Keychain, Engraved Custom Acrylic, Song Keychain Birthday Valentine's Day Gift"
        },
        {
            name: "Amberj",
            rating: 5,
            comment: "I had my chain for 4 years now still holding up great thanks",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/5_72fe758d-cbf1-4228-9a94-6af455784aaa.webp?v=1764149180", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/55_18ba8a6c-5d8b-40f6-80f7-5b10cba88dc0.webp?v=1764149235", 
            productTitle: "Men's Photo Tag Necklace With Engraving Stainless Steel"
        }
    ];
 
    const container = document.getElementById('customers-container'); 
    const loadMoreBtn = document.getElementById('load-more-btn'); 
    let currentIndex = 0;
    const itemsPerLoad = 10;
 
    // 初始加载 
    loadInitialItems();
 
    // 加载更多函数 
    function loadInitialItems() {
        loadItems(itemsPerLoad);
    }
 
    function loadMoreItems() {
        loadItems(itemsPerLoad);
    }
 
    function loadItems(count) {
        const endIndex = Math.min(currentIndex  + count, customerData.length); 
        
        for (let i = currentIndex; i < endIndex; i++) {
            const item = customerData[i];
            container.appendChild(createCustomerItem(item)); 
        }
        
        currentIndex = endIndex;
        updateButtonState();
    }
 
    function createCustomerItem(item) {
        const li = document.createElement('li'); 
        li.className  = 'customer-items';
        li.innerHTML  = `
            <div class="review-close-new"><i class="photofont icon photo-close"></i></div>
            <div class="customers-images">
                <img src="${item.userImage}" alt="${item.name}" data-maximg="${item.userImage}"  class="imagesmax" loading="lazy">
            </div>
            <div class="content-right">
                <div class="customers-international">
                    <div class="customers-tittle">
                        ${item.name}  <span class="circle-right"></span>
                    </div>
                    <div class="customers-start">
                        ${'<span class="photofont icon photo-iconfontstart"></span>'.repeat(item.rating)} 
                    </div>
                    <div class="customers-content">${item.comment}</div> 
                </div>
                <div class="customers-product">
                    <div class="review-product-preview">
                        <img src="${item.productImage}" alt="${item.productTitle}" loading="lazy">
                        <div class="customers-modal-layout">
                            <span>${item.productTitle}</span> 
                        </div>
                    </div>
                </div>
            </div>
        `;
        return li;
    }
 
    function updateButtonState() {
        if (currentIndex >= customerData.length)  {
            loadMoreBtn.disabled  = true;
            loadMoreBtn.textContent  = 'NO MORE REVIEWS';
        }
    }
    
    const element = document.getElementById('load-more-btn'); 
    if (element) {
       loadMoreBtn.addEventListener('click',  loadMoreItems);
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comments_lists_family"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.customers-images  img').forEach(img => {
	  img.addEventListener('click',  () => {
	    const modal = document.createElement('div'); 
	    modal.innerHTML  = `
	      <div style="position:fixed;top:0;left:0;width:100%;height:100%;
	        background:rgba(0,0,0,0.8);z-index:999;display:flex;
	        justify-content:center;align-items:center;">
	        <img src="${img.dataset.maximg  || img.src}"  style="max-width:90%;max-height:90%">
	      </div>
	    `;
	    modal.querySelector('div').addEventListener('click',  () => modal.remove()); 
	    document.body.appendChild(modal); 
	  });
	});

    document.addEventListener('DOMContentLoaded',  function() {
        // 所有客户评价数据 
        const customerData = [
            {
                name: "lakehousefun",
                rating: 5,
                comment: "I finally received my sweatshirt shirt and I LOVE IT!!! It's soft and comfy and not super heavy. I love that I have something with all my fur babies names on it. I would order from here again knowing the delivery is a bit longer than expected.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1_42b8e7a9-81d1-4a69-85ad-c6c8d7843b6a.png?v=1772760201", 
                title: "Would highly recommend!"
            },
            {
                name: "Carol Ruth",
                rating: 5,
                comment: "I am in love with my shirt(it can connect me closely with my dog.) and want to thank you for your great service, it did take a bit longer to get than expected but I got it and it is beautiful ~ Thank you for the exceptional customer service",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3dd2bc0a5dd26b8eba9d5b26bd892fc7.png?v=1772764288", 
                title: "Beautiful"
            },
            {
                name: "mbockman",
                rating: 5,
                comment: "The ornament was perfect and turned out great!We uploaded our favorite family photo and the result is stunning. The acrylic is clear and durable, and the shape perfectly captures our whole crew.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/aaedd7fe8291f99f15128eb34848c9c3.png?v=1772764434", 
                title: "Look very nice."
            },
            {
                name: "Sara Valenti As",
                rating: 5,
                comment: "Our family loved this piece with name. The acrylic shines so beautifully on the tree and makes the season even warmer.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/5a5ba826614f04256d3a6ae9b264a5cf.png?v=1772764527", 
                title: "pictured & described."
            },
            {
                name: "AWESOME",
                rating: 5,
                comment: "Mothers day present arrived my mother absolutely loved it! Thank you - perfect as described,each birth month flower represents one of her kids and grandkids.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/660f2bc47a84a745f51e22e32dd1b028.png?v=1772764622", 
                title: "SUE McBride"
            },
            {
                name: "Awele Nwabardi",
                rating: 5,
                comment: "Got this mug for my husband and he absolutely loved it. Seeing the family photo on it really made his day.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/0c2207dcf6ee14631cd1833e62d2ace3.png?v=1772764825", 
                title: "Great quality and beautiful."
            },
            {
                name: "Amanda",
                rating: 5,
                comment: "Order this blanket for my daughter's birthday.My daughter was very happy to receive it and said that she would be surrounded by warmth this winter.It was more beautiful than I expected and it was so soft and cuddly",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1db8a6ddcc24392fcf4a7f58213976f7.png?v=1772765051", 
                title: "Wonderful"
            },
            {
                name: "Paddock",
                rating: 5,
                comment: "A perfect gift for elders! It's thoughtful and beautiful; placing it by the bedside will bring them a constant sense of love.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/9bf52abf7229464589be7eb5248947a5.png?v=1772765355", 
                title: "Very satisfied Donna"
            },
            {
                name: "Heather Higgins",
                rating: 5,
                comment: "A perfect gift for elders! It's thoughtful and beautiful; placing it by the bedside will bring them a constant sense of love.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/67b8338e24cf607d43ba1f5dade2dbf9.png?v=1772765773", 
                title: "Meaningful Keepsake"
            },
            {
                name: "Barbara",
                rating: 5,
                comment: "I just love it. I always order a ornament every year for my tree. Seeing each name makes it feel like every one of us is right there, even when we can’t be together.It was made perfect, great service, and got it quick.I would for sure order from this company again.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4beb610a2af3c9082f48f055412c1762.png?v=1772765725", 
                title: "Great Memories.."
            },
            {
                name: "William A.",
                rating: 5,
                comment: "This is so cute and amazing gift for papas i loved",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/29085bec88fe66c8833f6fce54e6dd0c.png?v=1772765930", 
                title: "Love it!"
            },
            {
                name: "Hailey Wells",
                rating: 5,
                comment: "The dad puzzle was everything and more. It arrived prior to Father's Day. It was exactly as described. I would definitely purchase from them again .",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3cc2474347e1a297c581932c5c4576b8.png?v=1772766090", 
                title: "Stunning!"
            },
            {
                name: "Colin Finney",
                rating: 5,
                comment: "I ordered this for my sister in law for Christmas. She loves polar bears and can sometimes be hard to find the perfect gift for.And this product depicts a family tightly embracing each other, which is very loving.",
                userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/iap_600x600.6583156571_7q7m3zcg.webp?v=1772766352", 
                title: "This was perfect!"
            }
        ];
    
        const container = document.getElementById('family-customers-container'); 
        const loadMoreBtn = document.getElementById('load-more-btn'); 
        let currentIndex = 0;
        const itemsPerLoad = 12;
    
        // 初始加载 
        loadInitialItems();
    
        // 加载更多函数 
        function loadInitialItems() {
            loadItems(itemsPerLoad);
        }
    
        function loadMoreItems() {
            loadItems(itemsPerLoad);
        }
    
        function loadItems(count) {
            const endIndex = Math.min(currentIndex  + count, customerData.length); 
            
            for (let i = currentIndex; i < endIndex; i++) {
                const item = customerData[i];
                container.appendChild(createCustomerItem(item)); 
            }
            
            currentIndex = endIndex;
            updateButtonState();
        }
    
        function createCustomerItem(item) {
            const li = document.createElement('li'); 
            li.className  = 'customer-items';
            li.innerHTML  = `
                <div class="review-close-new"><i class="photofont icon photo-close"></i></div>
                <div class="customers-images">
                    <img src="${item.userImage}" alt="${item.name}" data-maximg="${item.userImage}"  class="imagesmax" loading="lazy">
                </div>
                <div class="content-right">
                    <div class="customers-international">
                        <div class="star-rating" data-product-id="8596095598759">
                            <div class="jdgm-prev-badge" data-average-rating="4.98" data-number-of-reviews="102" data-number-of-questions="0"> 
                                <span class="jdgm-prev-badge__stars" data-score="4.98" tabindex="0" aria-label="4.98 stars" role="button"> 
                                    <span class="jdgm-star jdgm--on"></span>
                                    <span class="jdgm-star jdgm--on"></span>
                                    <span class="jdgm-star jdgm--on"></span>
                                    <span class="jdgm-star jdgm--on"></span>
                                    <span class="jdgm-star jdgm--on"></span> 
                                </span> 
                            </div>
                        </div>
                        <div class="customers-tittle">
                            ${item.name}  <span class="circle-right"></span>
                        </div>
                        <div class="customers-start">
                            ${'<span class="photofont icon photo-iconfontstart"></span>'.repeat(item.rating)} 
                        </div>
                        <div class="customers-comment-title">${item.title}</div>
                        <div class="customers-content">${item.comment}</div> 
                    </div>
                </div>
            `;
            return li;
        }
    
        function updateButtonState() {
            if (currentIndex >= customerData.length)  {
                loadMoreBtn.disabled  = true;
                loadMoreBtn.textContent  = 'NO MORE REVIEWS';
            }
        }
        
        const element = document.getElementById('load-more-btn'); 
        if (element) {
            loadMoreBtn.addEventListener('click',  loadMoreItems);
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-valentines-day-tabs"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {

        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.pick-tabs-container'), 
                tabsList: container.querySelector('.pick-tabs-list'), 
                tabs: container.querySelectorAll('.pick-tab-button'),  
                slides: container.querySelectorAll('.pick-carousel-slide'),  
                prevBtn: container.querySelector('.pick-arrow.pick-prev'),  
                nextBtn: container.querySelector('.pick-arrow.pick-next'), 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            
            this.updateTabScroll(); 

            this.bindDrag();
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-pick-collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product_Valentines_day_gift_idea_tabs"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {

        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.gift_idea_tabs-container'), 
                tabsList: container.querySelector('.gift_idea_tabs-list'), 
                tabs: container.querySelectorAll('.gift_idea_tab-button'),  
                slides: container.querySelectorAll('.gift_idea_carousel-slide'),  
                prevBtn: container.querySelector('.gift_idea_arrow.gift_idea_prev'),  
                nextBtn: container.querySelector('.gift_idea_arrow.gift_idea_next'), 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            
            this.updateTabScroll(); 

            this.bindDrag();
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-gift_idea_collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product_Valentines_day_series_tabs"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {
        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.tabs-container'), 
                tabsList: container.querySelector('.tabs-list'), 
                tabs: container.querySelectorAll('.tab-button'),  
                slides: container.querySelectorAll('.carousel-slide'),  
                prevBtn: container.querySelector('.arrow.prev'),  
                nextBtn: container.querySelector('.arrow.next'), 
                indicatorsContainer: container.querySelector('.tab-indicators') 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            this.createIndicators(); 
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 

            this.bindDrag();
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            this.updateTabScroll(); 
        }
        
        createIndicators() {
            this.DOM.indicatorsContainer.innerHTML  = '';
            
            for (let i = 0; i < this.DOM.tabs.length;  i++) {
                const indicator = document.createElement('div'); 
                indicator.className  = 'tab-indicator';
                if (i === this.currentIndex)  {
                    indicator.classList.add('active'); 
                }
                
                indicator.addEventListener('click',  () => {
                    this.currentIndex  = i;
                    this.updateActiveState(); 
                });
                
                this.DOM.indicatorsContainer.appendChild(indicator); 
            }
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));  
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            const indicators = this.DOM.indicatorsContainer.querySelectorAll('.tab-indicator'); 
            indicators.forEach((indicator,  index) => {
                indicator.classList.toggle('active',  index === this.currentIndex); 
            });
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product_birthday_tabs"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {
        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.tabs-container'), 
                tabsList: container.querySelector('.tabs-list'), 
                tabs: container.querySelectorAll('.tab-button'),  
                slides: container.querySelectorAll('.carousel-slide'),  
                prevBtn: container.querySelector('.arrow.prev'),  
                nextBtn: container.querySelector('.arrow.next'), 
                indicatorsContainer: container.querySelector('.tab-indicators') 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            this.createIndicators(); 
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 

            this.bindDrag();
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            this.updateTabScroll(); 
        }
        
        createIndicators() {
            this.DOM.indicatorsContainer.innerHTML  = '';
            
            for (let i = 0; i < this.DOM.tabs.length;  i++) {
                const indicator = document.createElement('div'); 
                indicator.className  = 'tab-indicator';
                if (i === this.currentIndex)  {
                    indicator.classList.add('active'); 
                }
                
                indicator.addEventListener('click',  () => {
                    this.currentIndex  = i;
                    this.updateActiveState(); 
                });
                
                this.DOM.indicatorsContainer.appendChild(indicator); 
            }
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));  
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            const indicators = this.DOM.indicatorsContainer.querySelectorAll('.tab-indicator'); 
            indicators.forEach((indicator,  index) => {
                indicator.classList.toggle('active',  index === this.currentIndex); 
            });
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["productc_img_tabs_list"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {

        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.img_productc_tabs-container'), 
                tabsList: container.querySelector('.img_productc_tabs-list'), 
                tabs: container.querySelectorAll('.img_productc_tab-button'),  
                slides: container.querySelectorAll('.img_productc_carousel-slide'),  
                prevBtn: container.querySelector('.img_productc_arrow.img_productc_prev'),  
                nextBtn: container.querySelector('.img_productc_arrow.img_productc_next'), 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            
            this.updateTabScroll(); 

            this.bindDrag();
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-img_productc_collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["productc_img_tabs_list_one"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {

        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.img_productc_one_tabs-container'), 
                tabsList: container.querySelector('.img_productc_one_tabs-list'), 
                tabs: container.querySelectorAll('.img_productc_one_tab-button'),  
                slides: container.querySelectorAll('.img_productc_one_carousel-slide'),  
                prevBtn: container.querySelector('.img_productc_one_arrow.img_productc_one_prev'),  
                nextBtn: container.querySelector('.img_productc_one_arrow.img_productc_one_next'), 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            
            this.updateTabScroll(); 

            this.bindDrag();
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-img_productc_one_collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["productc_tabs_list"] && !Shopify.designMode) return;
  try {
    class CollectionCarousel {

        constructor(container) {
            this.DOM = {
                container,
                tabsContainer: container.querySelector('.productc_tabs-container'), 
                tabsList: container.querySelector('.productc_tabs-list'), 
                tabs: container.querySelectorAll('.productc_tab-button'),  
                slides: container.querySelectorAll('.productc_carousel-slide'),  
                prevBtn: container.querySelector('.productc_arrow.productc_prev'),  
                nextBtn: container.querySelector('.productc_arrow.productc_next'), 
            };
            
            this.currentIndex  = 0;
            this.maxVisibleTabs  = 0;
            this.tabScrollPosition  = 0;
            this.tabWidth  = 0;
            this.containerWidth  = 0;

            this._isDragging = false;
            this._startX = 0;
            this._startY = 0;
            this._startScroll = 0;
            this._wasDragged = false;
            
            this.init();  
        }
        
        init() {
            this.calculateLayout(); 
            
            this.DOM.tabs.forEach((tab,  index) => {
                tab.addEventListener('click',  (ev) => {
                    if (this._wasDragged) {
                        this._wasDragged = false;
                        ev.stopImmediatePropagation();
                        return;
                    }
                    this.currentIndex  = index;
                    this.updateActiveState();  
                    this.scrollToCurrentTab();
                }, { passive: true });
            });
            
            this.DOM.prevBtn.addEventListener('click',  () => this.navigateTabs(-1));  
            this.DOM.nextBtn.addEventListener('click',  () => this.navigateTabs(1));  
            
            window.addEventListener('resize',  () => {
                this.calculateLayout(); 
            });
            
            this.updateActiveState(); 
        }
        
        calculateLayout() {
            this.containerWidth  = this.DOM.tabsContainer.offsetWidth; 
            const firstTab = this.DOM.tabs[0]; 
            if (firstTab) {
                const style = window.getComputedStyle(firstTab); 
                const margin = parseInt(style.marginRight)  || 0;
                this.tabWidth  = firstTab.offsetWidth  + margin;
            }
            
            this.maxVisibleTabs  = Math.floor(this.containerWidth  / this.tabWidth); 
            
            this.updateTabScroll(); 

            this.bindDrag();
        }
        
        navigateTabs(direction) {
            const newIndex = (this.currentIndex  + direction + this.DOM.tabs.length)  % this.DOM.tabs.length; 
            this.currentIndex  = newIndex;
            
            this.updateActiveState(); 
            this.scrollToCurrentTab(); 
        }
        
        scrollToCurrentTab() {
            const tabOffset = this.currentIndex  * this.tabWidth; 
            const containerCenter = this.containerWidth  / 2;
            const tabCenter = tabOffset + (this.tabWidth  / 2);
            
            let targetScroll = tabCenter - containerCenter;
            
            const maxScroll = this.DOM.tabsList.scrollWidth  - this.containerWidth; 
            targetScroll = Math.max(0,  Math.min(targetScroll,  maxScroll));
            
            this.DOM.tabsList.style.transform  = `translateX(-${targetScroll}px)`;
            this.tabScrollPosition  = targetScroll;
        }
        
        updateTabScroll() {
            this.DOM.tabsList.style.transform  = `translateX(-${this.tabScrollPosition}px)`; 
        }

        bindDrag() {
            const container = this.DOM.tabsContainer;
            const list = this.DOM.tabsList;
            if (!container || !list) return;

            const onPointerDown = (e) => {
                if (list.scrollWidth <= container.offsetWidth) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                this._isDragging = true;
                this._startX = clientX;
                this._startY = clientY;
                this._startScroll = this.tabScrollPosition || 0;
                this._dragPointerId = e.pointerId || null;
            };

            const onPointerMove = (e) => {
                if (!this._isDragging) return;

                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const clientY = e.touches ? e.touches[0].clientY : e.clientY;

                const dx = clientX - this._startX;
                const dy = clientY - this._startY;

                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
                    this._isDragging = false;
                    return;
                }

                e.preventDefault?.();

                const maxScroll = Math.max(0, list.scrollWidth - container.offsetWidth);
                let newScroll = this._startScroll - dx;
                newScroll = Math.max(0, Math.min(newScroll, maxScroll));
                this.tabScrollPosition = newScroll;
                list.style.transform = `translateX(-${this.tabScrollPosition}px)`;

                if (Math.abs(dx) > 6) this._wasDragged = true;
            };

            const onPointerUp = () => {
                if (!this._isDragging) return;
                this._isDragging = false;

                const moved = Math.abs(this.tabScrollPosition - this._startScroll);
                if (moved < 8) {
                    this._wasDragged = false;
                } else {
                    const approxIndex = Math.round((this.tabScrollPosition + (this.containerWidth / 2) - (this.tabWidth / 2)) / this.tabWidth);
                    this.currentIndex = Math.min(Math.max(approxIndex, 0), this.DOM.tabs.length - 1);
                    this.updateActiveState();
                    this.scrollToCurrentTab();
                }

                setTimeout(() => { this._wasDragged = false; }, 50);
            };

            container.addEventListener('touchstart', onPointerDown, { passive: true });
            container.addEventListener('touchmove', onPointerMove, { passive: false });
            container.addEventListener('touchend', onPointerUp);

            container.addEventListener('pointerdown', onPointerDown, { passive: true });
            window.addEventListener('pointermove', onPointerMove, { passive: false });
            window.addEventListener('pointerup', onPointerUp);
            window.addEventListener('pointercancel', onPointerUp);
        }
        
        updateActiveState() {
            this.DOM.tabs.forEach(tab  => tab.classList.remove('active'));
            this.DOM.tabs[this.currentIndex].classList.add('active');  
            
            this.DOM.slides.forEach(slide  => slide.classList.add('hidden'));  
            this.DOM.slides[this.currentIndex].classList.remove('hidden');  
            
            this.DOM.container.dispatchEvent(new  CustomEvent('carouselChange', {
                detail: {
                    collectionHandle: this.DOM.slides[this.currentIndex].dataset.collection   
                }
            }));
        }
    }
    
    document.addEventListener('DOMContentLoaded',  () => {
        document.querySelectorAll('[data-productc_collection-carousel]').forEach(el  => {
            new CollectionCarousel(el);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs_collection_comment"] && !Shopify.designMode) return;
  try {
    class ResponsiveCommentCarousel {
        constructor(element) {
            this.carousel = element;
            this.track = element.querySelector('.comment_tabs-list');
            this.slides = Array.from(this.track.children).filter(el => el.children.length > 0);
            this.prevButton = element.querySelector('.comment_prev');
            this.nextButton = element.querySelector('.comment_next');
            this.settings = {
                animationDuration: 500,
                slidesPerRow: this.getSlidesPerRowForCurrentScreen(),
                originalSlideCount: this.slides.length,
                currentSlideIndex: 0,
                isAnimating: false 
            };
            
            this.init();
        }
    
        init() {
            this.updateSlideWidth();
            this.setupEventListeners();
            this.updateButtonStates();
        }
    
        updateSlideWidth() {
            const visibleSlides = this.getSlidesPerRowForCurrentScreen();
            this.settings.slideWidth = this.carousel.offsetWidth / 
                Math.min(visibleSlides, this.settings.originalSlideCount);
            
            this.slides.forEach(slide => {
                slide.style.width = `${this.settings.slideWidth}px`;
            });
        }
    
        setupEventListeners() {
            this.prevButton.addEventListener('click', () => {
                if (this.canSlide(-1)) this.moveToSlide(-1);
            });
            
            this.nextButton.addEventListener('click', () => {
                if (this.canSlide(1)) this.moveToSlide(1);
            });
    
            window.addEventListener('resize', () => {
                this.updateSlideWidth();
                this.updateButtonStates();
            });
        }
    
        canSlide(direction) {
            const newIndex = this.settings.currentSlideIndex + direction;
            const maxIndex = this.settings.originalSlideCount - this.settings.slidesPerRow;
            return newIndex >= 0 && newIndex <= maxIndex;
        }
    
        moveToSlide(direction) {
            if (this.settings.isAnimating) return;
            
            this.settings.isAnimating = true;
            this.settings.currentSlideIndex += direction;
            
            const targetPosition = -this.settings.currentSlideIndex * this.settings.slideWidth;
            this.track.style.transform = `translateX(${targetPosition}px)`;
            
            setTimeout(() => {
                this.settings.isAnimating = false;
                this.updateButtonStates();
            }, this.settings.animationDuration);
        }

        updateButtonStates() {
            this.prevButton.style.opacity = this.canSlide(-1) ? '1' : '0';
            this.nextButton.style.opacity = this.canSlide(1) ? '1' : '0';
        }
    
        getSlidesPerRowForCurrentScreen() {
            if (window.innerWidth < 768) return 1;
            if (window.innerWidth < 1024) return 2;
            return 4;
        }
    }
 
    document.addEventListener('DOMContentLoaded', function() {
        const carousels = document.querySelectorAll('.comment_collection-carousel');
        carousels.forEach(carousel => {
            new ResponsiveCommentCarousel(carousel);
        });
    });

    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
            const reviewItems = document.querySelectorAll('.comment_tab-button');
            
            reviewItems.forEach(item => {
                if (item.innerHTML.includes('loading-placeholder')) {
                    item.remove();
                }
                if (item.children.length === 0) {
                    item.remove();
                }
            });
        }, 3000);
    });
  } catch(e) { console.error(e); }
})();

})();
